/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

interface LabeledSwitchProps {
  id?: string;
  style?: React.CSSProperties;
  label: string;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  onSetCheckedState?: (checked: boolean) => void;
}

export default function LabeledSwitch({
  id,
  className,
  style,
  label,
  checked,
  disabled,
  onSetCheckedState,
}: LabeledSwitchProps) {
  return (
    <FormGroup style={style} className={className}>
      <FormControlLabel
        id={id}
        label={
          <Typography id={id && `${id}-label`} sx={{ fontWeight: 700 }}>
            {label}
          </Typography>
        }
        sx={{ marginLeft: 0, color: 'var(--gray37)' }}
        control={
          <Switch id={id && `${id}-switch`} checked={checked} onChange={(e) => onSetCheckedState?.(e.target.checked)} />
        }
        disabled={disabled}
        labelPlacement="start"
      />
    </FormGroup>
  );
}
